import Deferred from 'promise-deferred'
import { STATUS_APPLIED } from '@/constants/backend/transaction'
import { Blockchain } from '@/constants/blockchain'
import { getBackendTransactionStatus } from '@/servicies-ts/backend/me'
import { awaitTxBlockchain } from '@/servicies/blockchain/common'

export async function awaitTxBackend({ blockchain = Blockchain.Ethereum, txId, scId, event }) {
  const deferred = new Deferred()
  const interv = setInterval(async () => {
    getBackendTransactionStatus({ scId, txId, event, blockchain })
      .then((transaction) => {
        console.log('Transaction backend', transaction)
        if (transaction.status === STATUS_APPLIED) {
          clearInterval(interv)
          deferred.resolve()
        }
      })
      .catch((err) => {
        console.error(err)
      })
  }, 500)
  return deferred.promise
}

export async function awaitTxCombined({ blockchain = Blockchain.Ethereum, txId, scId, event }) {
  await awaitTxBlockchain({
    blockchain,
    txId,
  })

  const deferred = new Deferred()
  const interv = setInterval(async () => {
    getBackendTransactionStatus({ scId, txId, event, blockchain })
      .then((transaction) => {
        console.log('Transaction backend', transaction)
        if (transaction.status === STATUS_APPLIED) {
          clearInterval(interv)
          deferred.resolve()
        }
      })
      .catch((err) => {
        console.error(err)
      })
  }, 500)
  return deferred.promise
}
